module.exports = [{"id":1,"title":"General Information"}]


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/faqpage/resources/data/SHS-SPRINT/faq-topics.json
// module id = 3408
// module chunks = 0